// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","732":"f92ea73e","977":"255b6566"}[chunkId] + ".chunk.js";
};